// src/pages/Support/components/UserProfileCard.js

import React from "react";
import {
  Card,
  Avatar,
  Button,
  Tag,
  Divider,
  Tooltip,
  Typography,
  Space,
} from "antd";
import {
  MailOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import DetailItem from "./DetailItem";
import ArrowLeftCircleIcon from "../../../../Theme/CustomIcons/Icons/Arrow/ArrowLeftCircleIcon";
import LocationIcon from "../../../../Theme/CustomIcons/Icons/Location/LocationIcon";
import CalendarIcon from "../../../../Theme/CustomIcons/Icons/Time/CalendarIcon";
import ProfileIcon from "../../../../Theme/CustomIcons/Icons/Users/ProfileIcon";

const { Text, Title, Paragraph } = Typography;

const STATUS_COLORS = {
  opened: "orange",
  open: "orange",
  "in-progress": "blue",
  "In progress": "blue",
  Pending: "orange",
  Resolved: "green",
  resolved: "green",
  Closed: "red",
  closed: "red",
};

const UserProfileCard = ({ userData }) => {
  const navigate = useNavigate();
  console.log({ userData });
  if (!userData) return null;

  // ✅ Get status color safely
  const statusColor = STATUS_COLORS[userData.status] || "default";

  // ✅ Generate avatar initials from name
  const getInitials = (name) => {
    if (!name) return "?";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  // ✅ Render N/A if value is falsy or equal to "-"
  const formatValue = (val) => {
    if (!val || val === "-" || String(val).trim() === "") return "N/A";
    return val;
  };

  return (
    <Card
      style={{ height: "100%", borderRadius: 12 }}
      bodyStyle={{ padding: "20px" }}>
      {/* HEADER: Back Button + Ticket ID */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: 16,
        }}>
        <Tooltip title="Back to list">
          <ArrowLeftCircleIcon size="medium" onClick={() => navigate("/admin/support-listing")} style={{ fontSize: 26 }} />
        </Tooltip>

        <Tag
          style={{
            fontSize: 13,
            fontWeight: 600,
            fontFamily: "'SF Mono', 'Consolas', monospace",
            padding: "4px 12px",
            borderRadius: 6,
            border: "1px solid #d9d9d9",
          }}>
          #{formatValue(userData.ticketId)}
        </Tag>
      </div>

      <Divider style={{ margin: "12px 0" }} />

      {/* AVATAR + NAME + EMAIL */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 12,
          marginBottom: 20,
        }}>
        <Avatar
          size={52}
          src={userData.avatar}
          style={{
            fontSize: 18,
            fontWeight: 600,
            flexShrink: 0,
            backgroundColor: "#260b3b",
          }}>
          {getInitials(userData.name)}
        </Avatar>

        <div style={{ minWidth: 0, flex: 1 }}>
          <Title
            level={5}
            ellipsis
            style={{
              margin: 0,
              fontSize: 15,
              lineHeight: "22px",
              fontWeight: 600,
            }}>
            {formatValue(userData.name)}
          </Title>

          <Space direction="vertical" size={2} style={{ marginTop: 2 }}>
            <Text
              ellipsis
              style={{ fontSize: 12, color: "#8c8c8c", fontWeight: 500 }}
              title={userData.email}>
              <MailOutlined style={{ marginRight: 4 }} />
              {formatValue(userData.email)}
            </Text>

            <Text style={{ fontSize: 11, color: "#bfbfbf", fontWeight: 400 }}>
              ID: {formatValue(userData.employeeId)}
            </Text>
          </Space>
        </div>
      </div>

      <Divider style={{ margin: "12px 0" }} />

      {/* DETAILS SECTION */}
      <div className="user-details">
        <DetailItem
          icon={<LocationIcon size="small" />}
          label="COMPANY"
          value={formatValue(userData.company)}
        />

        <DetailItem
          icon={<CalendarIcon size="small" />}
          label="CREATED ON"
          value={formatValue(userData.createdAt)}
        />

        <DetailItem
          icon={<ProfileIcon size="small" />}
          label="SUBJECT"
          value={formatValue(userData.subject)}
        />

        <Divider style={{ margin: "16px 0" }} />

        {/* STATUS TAG */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}>
          <Text style={{ fontSize: 12, fontWeight: 600, color: "#595959" }}>
            STATUS
          </Text>

          <Tag
            color={statusColor}
            style={{
              margin: 0,
              borderRadius: 6,
              fontSize: 12,
              fontWeight: 600,
              padding: "4px 12px",
              textTransform: "uppercase",
            }}>
            {userData.status || "Pending"}
          </Tag>
        </div>
      </div>

      {/* BOTTOM SPACING */}
      <div style={{ marginTop: 20 }} />
    </Card>
  );
};

export default UserProfileCard;
